import { useWebPageForm } from "@/contexts/WebPageFormContext";
import Overview from "@/components/admin/Content/WebPages/Opportunities/Careers/Overview";
import HeroSection from "@/components/admin/Content/WebPages/Opportunities/Careers/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import ListCard from "@/components/admin/Content/WebPages/Opportunities/Careers/ListCard";
import WhatWeOffer from "@/components/admin/Content/WebPages/Opportunities/Careers/WhatWeOffer";
import OurGoals from "@/components/admin/Content/WebPages/Opportunities/Careers/OurGoals";
import GoalsCard from "@/components/admin/Content/WebPages/Opportunities/Careers/GoalsCard";
import BannerImage2 from "@/components/admin/Content/WebPages/Opportunities/Careers/BannerImage2";


const Careers = () => {
  const { pageData, isLoading } = useWebPageForm();

  // This array is created solely because of the numbering on the cards for the why join afsa section
  const joiningReasonsData = [
    pageData?.CAREER_BE_PART_OF_SPACE_REVOLUTION,
    pageData?.CAREER_COLLABORATE_WITH_INDUSTRY_LEADER,
    pageData?.CAREER_EMPOWER_AFRICA_THROUGH_TECHNOLOGY
  ]

  // This array is created solely because of the numbering on the cards for the equity diversity and inclusion section
  const equityAndDiversityData = [
    pageData?.CAREER_DIVERSITY_DRIVES_INNOVATION,
    pageData?.CAREER_INCLUSION_AND_EQUITY_MATTER,
    pageData?.CAREER_OPEN_TO_ALL_TALENT
  ];

  // This array is created solely because of the numbering on the cards for the goals section
  const goalsData = [
    pageData?.CAREER_USE_EARTH_OBSERVATION_TO_DRIVE_SUSTAINABLE_IMPACT,
    pageData?.CAREER_BRIDGE_THE_DIGITAL_DIVIDE_ACROSS_AFRICA,
    pageData?.CAREER_ADVANCE_SPACE_SCIENCE_AND_NAVIGATION
  ];

  if (isLoading) {
    return <FullPageSpinner />;
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 2xl:w-4/5 mx-auto">
      {/* Banner */}
      <HeroSection data={pageData?.CAREER_BANNER ?? {
        sectionTag: 'CAREER_BANNER',
        contentType: 'WITH_FILE',
        title: 'Careers Banner'
      }} />

      {/* Why Join Us */}
      <div className="flex flex-col gap-4">
        <Overview data={pageData?.CAREER_WHY_JOIN_AFSA ?? {
          sectionTag: 'CAREER_WHY_JOIN_AFSA',
          contentType: 'WITHOUT_FILE',
          title: 'Why Join AFSA'
        }} />

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {joiningReasonsData.map((section, index) => {
            const tags = [
              'CAREER_BE_PART_OF_SPACE_REVOLUTION',
              'CAREER_COLLABORATE_WITH_INDUSTRY_LEADER',
              'CAREER_EMPOWER_AFRICA_THROUGH_TECHNOLOGY'
            ];
            return (
              <ListCard
                key={index}
                data={section ?? { sectionTag: tags[index], contentType: 'WITHOUT_FILE', title: `Reason ${index + 1}` }}
                index={index + 1}
              />
            )
          })}
        </div>
      </div>

      {/* What We Offer */}
      <div className="grid md:grid-cols-2 gap-4 w-full h-auto">
        <WhatWeOffer data={pageData?.CAREER_WHAT_WE_OFFER ?? {
          sectionTag: 'CAREER_WHAT_WE_OFFER',
          contentType: 'WITHOUT_FILE',
          title: 'What We Offer'
        }} />
        <BannerImage2 data={pageData?.CAREER_BANNER_2 ?? {
          sectionTag: 'CAREER_BANNER_2',
          contentType: 'WITH_FILE'
        }} />
      </div>

      {/* Goals */}
      <div className="flex flex-col gap-6 p-4 md:p-8 lg:p-12 bg-wine-100 ">
        <OurGoals data={pageData?.CAREER_OUR_GOALS ?? {
          sectionTag: 'CAREER_OUR_GOALS',
          contentType: 'WITHOUT_FILE',
          title: 'Our Goals'
        }} />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {goalsData.map((section, index) => {
            const tags = [
              'CAREER_USE_EARTH_OBSERVATION_TO_DRIVE_SUSTAINABLE_IMPACT',
              'CAREER_BRIDGE_THE_DIGITAL_DIVIDE_ACROSS_AFRICA',
              'CAREER_ADVANCE_SPACE_SCIENCE_AND_NAVIGATION'
            ];
            return (
              <GoalsCard
                key={index}
                data={section ?? { sectionTag: tags[index], contentType: 'WITHOUT_FILE', title: `Goal ${index + 1}` }}
              />
            )
          })}
        </div>
      </div>

      {/* Equity Diversity Inclusion */}
      <div className="flex flex-col gap-4">
        <Overview data={pageData?.CAREER_EQUITY_DIVERSITY_INCLUSION ?? {
          sectionTag: 'CAREER_EQUITY_DIVERSITY_INCLUSION',
          contentType: 'WITHOUT_FILE',
          title: 'Equity, Diversity & Inclusion'
        }} />

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {equityAndDiversityData.map((section, index) => {
            const tags = [
              'CAREER_DIVERSITY_DRIVES_INNOVATION',
              'CAREER_INCLUSION_AND_EQUITY_MATTER',
              'CAREER_OPEN_TO_ALL_TALENT'
            ];
            return (
              <ListCard
                key={index}
                data={section ?? { sectionTag: tags[index], contentType: 'WITHOUT_FILE', title: `Value ${index + 1}` }}
              />
            )
          })}
        </div>

        <div className="grid " style={{display: "none"}}>
        
              <ListCard
                data={equityAndDiversityData[0] ?? { sectionTag: "CAREER_EQUITY_DIVERSITY_INCLUSION", contentType: 'WITHOUT_FILE', title: `Value` }}
              />
            
         
        </div>
      </div>
    </div>
  )
}

export default Careers